import { render, staticRenderFns } from "./PrescriptionInfoPage.vue?vue&type=template&id=6621590e&scoped=true"
import script from "./PrescriptionInfoPage.vue?vue&type=script&lang=js"
export * from "./PrescriptionInfoPage.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionInfoPage.vue?vue&type=style&index=0&id=6621590e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621590e",
  null
  
)

export default component.exports